import { Grid2, useMediaQuery } from "@mui/material";
import Products from "./Products";
import MobilePlan from "./MobilePlans"


export default function MainPhonePage() {
    // const isSmallScreen = useMediaQuery('(max-width:600px)')
    return (
        <main>
            <Grid2 >
                <Products />
            </Grid2>
        </main>
    )
}